export enum ExportFormatEnum {
  Zip = 'zip',
  Html = 'html',
  Markdown = 'md',
  Pdf = 'pdf',
  Docx = 'docx',
  Zapier = 'zapier',
  DesignMedia = 'design_media',
}

export enum PdfPaperSize {
  Letter = 'letter',
  Legal = 'legal',
  Tabloid = 'tabloid',
  A4 = 'A4',
}

export enum ExportRequestStateEnum {
  Requesting = 'requesting',
  Processing = 'processing',
  Successful = 'successful',
  Failed = 'failed',
}

export enum ModalStateEnum {
  Cancelling = 'cancelling',
  Export = 'export',
  Exporting = 'exporting',
  Exported = 'exported',
  ConnectWordPress = 'connectWordPress',
  ExportToFile = 'exportToFile',
  Zapier = 'zapier',
}

export type ExportViewState = { format: ExportFormatEnum; pdfPaperSize: PdfPaperSize }

export type ExportingViewState = ExportRequestStateEnum.Requesting | ExportRequestStateEnum.Processing

export type ExportedViewState =
  | { status: ExportRequestStateEnum.Successful; url: string; fileName: string }
  | { status: ExportRequestStateEnum.Failed }
